import React, { useContext, useState } from 'react';

import AJAX from 'common/AJAX';
import { CompanyContext } from 'common/containers/CompanyContainer';
import SourceFilter from 'common/subdomain/admin/AdminQueue/SourceFilters/SourceFilter';
import { useZendeskSourceFilter } from 'common/subdomain/admin/AdminQueue/SourceFilters/useZendeskSourceFilter';
import parseAPIResponse, { isDefaultSuccessResponse } from 'common/util/parseAPIResponse';

import SourceFiltersModal from './SourceFiltersModal';

import type { Integration } from 'common/subdomain/admin/AdminQueue/GettingStarted/constants';

type Props = {
  onClose: () => void;
  integration: Integration;
  enableIntegrationSync: (integration: Integration) => void;
};

const ZendeskSourceFiltersModal = ({ onClose, integration, enableIntegrationSync }: Props) => {
  const company = useContext(CompanyContext);
  const { zendesk } = company;
  const [selectedIds, setSelectedIds] = useState<string[] | null>(zendesk?.groupIDs ?? null);
  const { loading, error, options } = useZendeskSourceFilter(selectedIds);

  const [saveError, setSaveError] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const onSubmit = async () => {
    setSaving(true);
    setSaveError(false);

    const response = await AJAX.post('/api/zendesk/setGroups', { groupIDs: selectedIds });
    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
    });

    if (error) {
      setSaveError(true);
    } else {
      enableIntegrationSync(integration);
      onClose();
    }
    setSaving(false);
  };

  return (
    <SourceFiltersModal
      saving={saving}
      onClose={onClose}
      integration={integration}
      enableIntegrationSync={enableIntegrationSync}
      onSubmit={onSubmit}
      loading={loading}
      error={error}
      sourceFilter={
        <SourceFilter
          options={options}
          value={selectedIds ?? []}
          filterLabel="Filter by group"
          onChange={setSelectedIds}
          saveError={saveError}
        />
      }
    />
  );
};

export default ZendeskSourceFiltersModal;
